<!-- 平台-店铺 级联选择器 -->
<template>
  <div style="display: inline-block;">
    <el-select v-model="platform" filterable clearable placeholder="平台" size="medium" style="width: 120px;" @change="platformChange">
      <el-option v-for="platform in platformList" :key="platform.platformCode" :value="platform.platformCode" :label="platform.platformName"></el-option>
    </el-select>
    <el-select v-model="store" multiple filterable clearable collapse-tags placeholder="店铺" size="medium" style="margin-left: 15px; width: 200px;" @change="emit">
      <el-option v-for="store in storeList" :key="store.storeId" :value="store.storeId" :label="store.storeName"></el-option>
    </el-select>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
export default {
  data() {
    return {
      platform: undefined,
      store: undefined,
      // platformList: [],
      storeList: []
    }
  },
  created() {
    // this.getPlatform()
  },
  computed: {
    platformList() {
      return this.$store.state.platformList
    }
  },
  methods: {
    platformChange(platform) {
      this.store = undefined
      const platformItem = this.platformList.find(item => item.platformCode === platform)
      if (platformItem && Array.isArray(platformItem.children)) {
        this.storeList = platformItem.children
      } else {
        this.getStoreList(platform, platformItem)
      }
      this.$emit('change', {
        platformCode: this.platform,
        storeId: [...new Set(this.store)]
      })
    },
    getStoreList(platform, platformItem) {
      API.getStoreSelect({ platformCode: platform, userId: this.$store.getters.userId, storeStatus: 1, authorizeStatus: 1 }).then(result => {
        this.$set(platformItem, 'children', result.data)
        this.storeList = result.data
      })
    },
    emit: _.debounce(function() {
      this.$emit('change', {
        platformCode: this.platform,
        storeId: [...new Set(this.store)]
      })
    }, 1000),
    setDefaulValue({platform, store}) {
      this.platform = platform
      this.store = store
      // this.getPlatform().then(()=>{
      //   const platformItem = this.platformList.find(item => item.platformCode === platform)
      //   this.getStoreList(platform, platformItem)
      // })
    }
  }
}
</script>

<style>
.el-select .el-tag{
  max-width: 100px;
}
</style>
